module.exports = __webpack_public_path__ + "static/img/createdeadline.09283a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/createdeadline.png
// module id = r43o
// module chunks = 1